module.exports = __webpack_public_path__ + "media/images/online_talks/V&A-ff4bbea624a6a90a246542f314abca50.png";